let landingAPISetting: null | boolean = false;

// Setting to hide GDPR banner and switch off sending Analytics events to Xsolla

export const setHideGdprConsent = (value: boolean) => {
  landingAPISetting = value;
};

export const hideGdprConsent = () => !!landingAPISetting;
